import { useState, useEffect } from 'react';

/**
 * Hook to detect if the current viewport is mobile (< 1024px)
 * Matches Tailwind's `lg:` breakpoint
 * 
 * @returns {boolean} True if viewport width is less than 1024px
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 1024);
    
    // Check on mount
    checkMobile();
    
    // Listen for resize
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile;
}

export default useIsMobile;

